import { AgGridReact } from "ag-grid-react";
import { Splitter } from "@progress/kendo-react-layout";
import React, { useEffect, useState, useRef } from "react";
import moment from "moment";
import { sbaAxios } from "../../utils/sbaAxios";
import { getTrackingListsAPI, getProbability, getTrackingRecipientsAPI, getTrackingDetailsAPI, getDyanmicContactListDetails, getContactAccess, getPipelineStatus } from "../../../config/apiConfig";
const defaultPanes = [
   {
      size: "25%",
      min: "200px",
      collapsible: true,
   },
   {
      size: "25%",
      collapsible: false,
   },

];
const colDef = [
   { headerName: 'Email Template', field: 'TemplateName', floatingFilter: true, filter: "agTextColumnFilter", floatingFilter: true, filter: "agTextColumnFilter" },
   { headerName: 'Date', field: 'CreatedDate', valueFormatter: (e) => (moment(e.value).format('MM-DD-YYYY')), maxWidth: 200 }
];
export const Tracking = () => {
   const [templateTrackingList, setTemplateTrackingList] = useState([]);
   const [panes, setPanes] = useState(defaultPanes);
   const [sentRecipient, setSentRecipient] = useState([]);
   const [selectedListDetails, setSelectedListDetails] = useState({ TrackingListDetails: [], TrackingListCriteriaDetails: [] });
   const isInitialLoad = useRef(true);

   useEffect(() => {
      if (isInitialLoad.current) {
         fetchData();
         isInitialLoad.current = false;
      }
   }, []);
   const fetchData = async () => {
      const tempTrackingList = await getTrackingDetails();
      setTemplateTrackingList(val => tempTrackingList);
   };
   const getTrackingDetails = async () => {
      try {
         const response = await sbaAxios({ url: getTrackingDetailsAPI });
         return response;
      } catch (error) {
         return [];
      }
   };
   const onPanesAdjust = (event) => {
      setPanes(event.newState);
   };
   const getSentList = async (trackingID) => {
      try {
         const url = `?trackingId=${trackingID}`;
         const sentRecipients = await sbaAxios({ url: getTrackingListsAPI + url });
         setSelectedListDetails(sentRecipients)
      } catch (error) {
         setSelectedListDetails({ TrackingListDetails: [], TrackingListCriteriaDetails: [] });
      }
   }
   const templateTrackingRowCLick = (e) => {
      try {
         const trackingId = e.data.TrackingId
         getSentRecipient(trackingId);
         getSentList(trackingId);
      } catch (error) {

      }
   }
   const getSentRecipient = async (trackingID) => {
      try {
         const url = `?trackingId=${trackingID}`;
         const sentRecipients = await sbaAxios({ url: getTrackingRecipientsAPI + url });
         setSentRecipient(sentRecipients);
      } catch (error) {
         return [];
      }
   };
   const sentRecipientColDef = [
      { headerName: "Recipient Name", field: "ContactName" },
      { headerName: "Email", field: "BusinessEmail" },
   ];
   const trackingListColDef = [
      { headerName: "List Name", field: "ContactListName" },
      { headerName: "Type", field: "TypeOfListName" },
   ];

   return <>
      <Splitter panes={panes} onChange={onPanesAdjust}>
         <div className="pane-content">
            <div className="ag-theme-alpine " style={{ height: '70vh', width: '100%' }}>
               <AgGridReact
                  rowData={templateTrackingList}
                  columnDefs={colDef}
                  defaultColDef={{ flex: 1,resizable:true}}
                  rowSelection="single"
                  onRowClicked={(e) => { templateTrackingRowCLick(e) }}
               />
            </div>
         </div>
         <div className="pane-content">
            <div className="ag-theme-alpine " style={{ height: '70vh', width: '100%' }}>
               <AgGridReact
                  rowData={sentRecipient}
                  columnDefs={sentRecipientColDef}
                  defaultColDef={{ flex: 1, floatingFilter: true, filter: "agTextColumnFilter",resizable:true }}
                  rowSelection="single"
                  overlayNoRowsTemplate="<span>No Records to Show</span>"
               />
            </div>
         </div>
         <div className="pane-content ">
            <ListSection selectedListDetails={selectedListDetails} trackingListColDef={trackingListColDef}></ListSection>
         </div>
      </Splitter>

   </>
};



const ListSection = ({ selectedListDetails, trackingListColDef }) => {
   const [listDetails, setListDetails] = useState(null);
   useEffect(() => {
      setListDetails(val => (null));
   }, [selectedListDetails])
   const listTypeRowClick = async (e) => {
      try {
         if (e.data.TypeOfListName === "Dynamic") {
            const listDetails = await sbaAxios({ url: getDyanmicContactListDetails + e.data.ContactListId });
            setListDetails(listDetails[0]);
         }
         else {
            setListDetails(null);
         }
      } catch (error) {
         setListDetails(val => null);
      }
   };
   return <> {selectedListDetails?.TrackingListDetails.length>0 && 
      <div className="ag-theme-alpine" >
         <AgGridReact
            rowData={selectedListDetails?.TrackingListDetails}
            columnDefs={trackingListColDef}
            defaultColDef={{ flex: 1, floatingFilter: true, filter: "agTextColumnFilter",resizable:true }}
            rowSelection="single"
            overlayNoRowsTemplate="<span>No Records to Show</span>"
            onRowClicked={(e) => { listTypeRowClick(e) }}
            domLayout={"autoHeight"}
         />
      </div>}
      {listDetails?.ContactListId &&
         <div className="detail px-2 py-3 h-50" >
            <DynamicListParamsContainer data={listDetails}></DynamicListParamsContainer>
         </div>}
         
   </>
};
const DynamicListParamsContainer = ({ data }) => {
   const [listData, setListData] = useState(data);
   useEffect(() => {
      setListData(data);
   }, [data])
   return <>
      {data.SearchTypeId === 1 && <>
         <DynamicSearchTypeAsset data={listData} />
      </>}
      {data.SearchTypeId === 2 && <>
         <DynamicSearchTypePipeline data={listData} />
      </>}
      {data.SearchTypeId === 4 && <>
         <DynamicSearchTypeContact data={listData} />
      </>}
   </>
}
const DynamicSearchTypeAsset = ({ data }) => {
   const [selectedAsset, setSelectedAsset] = useState([]);
   const [SelectedCriteria, setSelectedCriteria]=useState([]);
   useEffect(() => {
      fetchAsset();
   }, [data]);
   const fetchAsset = () => {
      const AssetIDs = data?.Param2?.split(',');
      const AssetNames = data?.Param2Value?.split('~@@@~');
      if (AssetIDs.length > 0) {
         const AssetByList = AssetIDs.map((item, index) => {
            return {
               "AssetType": null,
               "AssetValue": null,
               "AssetId": parseInt(item),
               "AssetName": AssetNames[index],
               "AccountTypeId": null
            }
         });
         setSelectedAsset(AssetByList);
      };
      sbaAxios({ url: `${getContactAccess}`, method: 'get' }).then((response) => {
             const ItemId=data?.Param3?.split(',').map(Number)
             const selectedOptions=[...response].filter(item => ItemId.includes(item.ContactAccessId))
             setSelectedCriteria([...selectedOptions]);
            })
   };
   const selectedAssetColDef = [
      { headerName: "Selected Asset", field: "AssetName", tooltipField: 'AssetName', flex: 1 }
   ];
   const DateOptions = [
      { value: 1, text: 'YTD' },
      { value: 2, text: 'NYearBack' },
      { value: 3, text: 'CalendarYear' },
      { value: 4, text: 'NMonthsBack' }
   ];
   const YTDdata = [
      { value: 0, text: 'Today' },
      { value: 1, text: 'Month-1' },
      { value: 2, text: 'Month-2' },
      { value: 3, text: 'Month-3' },
      { value: 4, text: 'Month-4' },
   ];
   const CalendarYeardata = [
      { value: 0, text: 'Current Year' },
      { value: 1, text: 'Year-1' },
      { value: 2, text: 'Year-2' },
      { value: 3, text: 'Year-3' },
      { value: 4, text: 'Year-4' },
   ];
   return <>
   <div className="d-flex gap-2">
      <div className="ag-theme-alpine w-50 pt-0">
         <AgGridReact
            columnDefs={selectedAssetColDef}
            rowData={selectedAsset}
            rowSelection={'single'}
            enableBrowserTooltips={true}
            defaultColDef={{resizable:true}}
         />
      </div>
      <div className="w-100">
         {parseInt(data.Param1) > 0 && <>
               <div className="mb-2">
                  <span className="fw-medium">Date Options</span>
                  <p className="fw-medium">{DateOptions[parseInt(data.Param1) - 1].text} </p>
               </div>
               {parseInt(data.Param1) === 1 && 
                  <>
                     <div className="mb-2">
                        <span className="fw-medium">End Date</span>
                        <p className="fw-medium">{YTDdata[parseInt(data.Param1Value)].text}</p>
                     </div>
                  </>}
               {parseInt(data.Param1) === 2 && 
                  <>
                     <div className="mb-2">
                        <span className="fw-medium">Year</span>
                        <p className="fw-medium"> {parseInt(data.Param1Value)}</p>
                     </div>
                  </>}
               {parseInt(data.Param1) === 3 && 
                  <>
                  <div className="mb-2">
                        <span className="fw-medium">Year</span>
                        <p className="fw-medium"> {CalendarYeardata[parseInt(data.Param1Value)].text}</p>
                     </div>
                  </>}
               {parseInt(data.Param1) === 4 &&
                  <>
                  <div className="mb-2">
                        <span className="fw-medium">Month</span>
                        <p className="fw-medium"> {parseInt(data.Param1Value)}</p>
                     </div>
                  </>}
         </>}
            <div className="mb-2">
               <span className="fw-medium">Selected Criteria</span>
               <p className="fw-medium">{SelectedCriteria.map(item=>item.ContactAccessName).join(' ,')} </p>
            </div>
      </div>
      </div>
   </>
}
const DynamicSearchTypeContact = ({ data }) => {
   const [selectedContactListCriteria, setSelectedContactListCriteria] = useState([]);
   useEffect(() => {
      fetchAsset();
   }, [data]);
   const fetchAsset = () => {
      sbaAxios({ url: `${getContactAccess}`, method: 'get' }).then((response) => {
         const ItemId = data.Param1Value.split(',').map(Number)
         const selectedOptions = [...response].filter(item => ItemId.includes(item.ContactAccessId))
         setSelectedContactListCriteria([...selectedOptions]);
      })
   };
   const SelectedCriteriaColDef = [
      { headerName: "Selected Access", field: "ContactAccessName", tooltipField: 'ContactAccessName', flex: 1 }
   ];
   return <>
      <div className="ag-theme-alpine w-50 pt-0">
         <AgGridReact
            columnDefs={SelectedCriteriaColDef}
            rowData={selectedContactListCriteria}
            rowSelection={'single'}
            enableBrowserTooltips={true}
            defaultColDef={{resizable:true}}
         >
         </AgGridReact>
      </div>
   </>
}
const DynamicSearchTypePipeline = ({ data }) => {
   const [selectedPipeline, setSelectedPipeline] = useState({});
   const [selectedProbability, setSelectedProbability] = useState({});
   useEffect(() => {
      fetchAsset();
   }, [data])
   const fetchAsset = () => {
      sbaAxios({ url: `${getPipelineStatus}`, method: 'get' }).then((response) => {
         setSelectedPipeline(response.find(item => item.PipelineStatusId === parseInt(data.Param3Value)));
      });
      sbaAxios({ url: `${getProbability}`, method: 'get' }).then((response) => {
         setSelectedProbability(response.find(item => item.PipelineProbabilityId === parseInt(data.Param1Value)));
      })
   };
   return <>
      <div className="h-50 pt-0">
         <div className="mb-2">
            <span className="fw-medium">Probability</span>
            <p className="fw-medium"> {selectedPipeline?.PipelineStatusName}</p>
         </div>
         <div className="mb-2">
            <span className="fw-medium">Status</span>
            <p className="fw-medium"> {selectedProbability?.PipelineProbilityName}</p>
         </div>
      </div>
   </>
}
